import React from 'react';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import Stack from 'atoms/Layout/Stack/Stack';
import NativeMobileAppsTextBlock from 'organisms/Homepage/NativeMobileAppsTextBlock/NativeMobileAppsTextBlock';
import NativeMobileAppsVerticalCards from 'organisms/Homepage/NativeMobileAppsVerticalCards/NativeMobileAppsVerticalCards';

const NativeMobileApps = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-none', 'spacing-4xl']}
    paddingBottom='spacing-7xl'
    paddingSm={['spacing-none', 'spacing-xl']}
    paddingBottomSm='spacing-4xl'
  >
    <Stack
      direction='column'
      gap='spacing-7xl'
      gapSm='spacing-4xl'
    >
      <NativeMobileAppsTextBlock />
      <NativeMobileAppsVerticalCards />
    </Stack>
  </SectionLayout>
);

export default NativeMobileApps;
